import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  UserInsightsInfluenceLoadFulfilledAction,
  UserInsightsInfluenceLoadPendingAction,
  UserInsightsInfluenceLoadRejectedAction,
} from '../../domains/userInsightsInfluences/actions.types';

import { UserInsightsInfluences } from './types';

export type UserInsightsInfluenceAction =
  | UserInsightsInfluenceLoadFulfilledAction
  | UserInsightsInfluenceLoadPendingAction
  | UserInsightsInfluenceLoadRejectedAction;

const initialState: UserInsightsInfluences = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<UserInsightsInfluences, UserInsightsInfluenceAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_INSIGHTS_INFLUENCE.LOAD_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'USER_INSIGHTS_INFLUENCE.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'USER_INSIGHTS_INFLUENCE.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userInsightsInfluences);
    default:
      return state;
  }
};

export default reducer;
